export const GET_CLIENT_AGENCY_NAMES_LIST_REQUEST =
  "GET_CLIENT_AGENCY_NAMES_LIST_REQUEST";
export const GET_CLIENT_AGENCY_NAMES_LIST_SUCCESS =
  "GET_CLIENT_AGENCY_NAMES_LIST_SUCCESS";
export const GET_CLIENT_AGENCY_NAMES_LIST_FAIL =
  "GET_CLIENT_AGENCY_NAMES_LIST_FAIL";
export const GET_CLIENT_AGENCY_NAMES_LIST_RESET =
  "GET_CLIENT_AGENCY_NAMES_LIST_RESET";

export const GET_CLIENT_AGENCY_DETAILS_REQUEST =
  "GET_CLIENT_AGENCY_DETAILS_REQUEST";
export const GET_CLIENT_AGENCY_DETAILS_SUCCESS =
  "GET_CLIENT_AGENCY_DETAILS_SUCCESS";
export const GET_CLIENT_AGENCY_DETAILS_FAIL = "GET_CLIENT_AGENCY_DETAILS_FAIL";
export const GET_CLIENT_AGENCY_DETAILS_RESET =
  "GET_CLIENT_AGENCY_DETAILS_RESET";

export const ADD_CLIENT_AGENCY_DETAILS_REQUEST =
  "ADD_CLIENT_AGENCY_DETAILS_REQUEST";
export const ADD_CLIENT_AGENCY_DETAILS_SUCCESS =
  "ADD_CLIENT_AGENCY_DETAILS_SUCCESS";
export const ADD_CLIENT_AGENCY_DETAILS_FAIL = "ADD_CLIENT_AGENCY_DETAILS_FAIL";
export const ADD_CLIENT_AGENCY_DETAILS_RESET =
  "ADD_CLIENT_AGENCY_DETAILS_RESET";

export const GET_CLIENT_AGENCY_LIST_REQUEST = "GET_CLIENT_AGENCY_LIST_REQUEST";
export const GET_CLIENT_AGENCY_LIST_SUCCESS = "GET_CLIENT_AGENCY_LIST_SUCCESS";
export const GET_CLIENT_AGENCY_LIST_FAIL = "GET_CLIENT_AGENCY_LIST_FAIL";
export const GET_CLIENT_AGENCY_LIST_RESET = "GET_CLIENT_AGENCY_LIST_RESET";

export const APPLY_CLIENT_AGENCY_REQUEST = "APPLY_CLIENT_AGENCY_REQUEST";
export const APPLY_CLIENT_AGENCY_SUCCESS = "APPLY_CLIENT_AGENCY_SUCCESS";
export const APPLY_CLIENT_AGENCY_FAIL = "APPLY_CLIENT_AGENCY_FAIL";
export const APPLY_CLIENT_AGENCY_RESET = "APPLY_CLIENT_AGENCY_RESET";

export const REMOVE_CLIENT_AGENCY_REQUEST = "REMOVE_CLIENT_AGENCY_REQUEST";
export const REMOVE_CLIENT_AGENCY_SUCCESS = "REMOVE_CLIENT_AGENCY_SUCCESS";
export const REMOVE_CLIENT_AGENCY_FAIL = "REMOVE_CLIENT_AGENCY_FAIL";
export const REMOVE_CLIENT_AGENCY_RESET = "REMOVE_CLIENT_AGENCY_RESET";
